<template>
    <div class="page">
        <Headers></Headers>

        <div class="banner">

            <!-- 本页标题 -->
            <div class="banner_title">{{$t('page2.Background')}}</div>

            <!-- 内容 -->
            <a-row type="flex" class="mg_t" justify="space-between">
                <a-col :span="15">
                    <div class="t1">{{$t('page3.Purpose')}}<span class="btm_line"></span></div>
                    <div class="txt">{{$t('page3.PurposeTxt')}}</div>
                </a-col>
                <a-col>
                    <img src="@/assets/img/t_img.png" class="img_box" alt="">
                </a-col>
            </a-row>

            <a-row type="flex" class="mg_t" justify="space-between">
                <a-col :span="15">
                    <div class="t1">{{$t('page3.EvaluationSystem')}}<span class="btm_line"></span></div>
                    <div class="txt">{{$t('page3.EvaluationSystemTxt')}}</div>
                </a-col>
                <a-col :span="9">
                    <!-- <img src="@/assets/img/cank.png" class="cank_box" alt=""> -->
                    <div class="charts">
                        <Echarts v-if="PdftStore.fromData.questionnaireInfo" :name="'page3echarts'"/>
                    </div>
                </a-col>
            </a-row>

            <a-row type="flex" class="mg_t" justify="space-between">
                <a-col :span="15">
                    <div class="t1">{{$t('page3.AppraisalIncome')}}<span class="btm_line"></span></div>
                    <div class="txt">{{$t('page3.AppraisalIncomeTxt')}}</div>
                </a-col>
            </a-row>

            <!-- <a-row type="flex" class="mg_t" justify="space-between">
                <a-col :span="15">
                    <div class="t1">{{$t('page3.AboutTUVSUD')}}<span class="btm_line"></span></div>
                    <div class="txt">{{$t('page3.AboutTUVSUDTxt')}}</div>
                </a-col>
                <a-col :span="9">
                    <div class="mg_c">
                        <img src="@/assets/img/onelogo.png" class="tuvlogo_box" alt="">
                    </div>
                </a-col>
            </a-row> -->

            <!-- <div class="btm_banner">
                该报告由ACNAC出具并发布
            </div> -->
            <div class="logo_txt">
                <!-- <div>本报告由ACNAC委托</div>
                <img src="@/assets/img/min_tuv.png" class="img_min" alt="">
                <div>TÜV SÜD核证并发布</div> -->
            </div>

            <div class="flxed">01</div>
        </div>
    </div>
</template>

<script>
import { reactive, toRefs, onBeforeMount, onMounted } from 'vue'
import { useRoute, useRouter } from 'vue-router';
import Headers from '../components/headers.vue'
import Echarts from '../components/echarts.vue'
import { usePdftStore } from '@/store/pdf'
export default {
    name: 'page3',
    components:{Headers,Echarts},
    setup() {
        const data = reactive({})
        //引入数据管理库
        const PdftStore = usePdftStore()
        onBeforeMount(() => {})
        onMounted(() => {})
        return {
            PdftStore,
            ...toRefs(data),
        }
    },
}

</script>
<style scoped lang='less'>
.page{
    width: 1512px;
    height: 2149px;
    margin: 0 auto;
    background: #FFFFFF;
    position: relative;
    .banner{
        width: 100%;
        padding: 0 130px;
        .banner_title{
            padding: 96px 0 40px 0;
            font-size: 72px;
            font-weight: 500;
            color: #013C89;
            line-height: 100px;
            border-bottom: 2px solid #013C89;
        }
        .mg_t{
            margin-top: 136px;
        }
        .t1{
            font-size: 32px;
            font-weight: 500;
            color: #333333;
            line-height: 45px;
        }
        .txt{
            font-size: 20px;
            font-weight: 400;
            color: #333333;
            line-height: 42px;
            margin-top: 24px;
            text-align: justify;
        }
        .btm_line{
            display: inline-block;
            width: 36px;
            height: 4px;
            background: #0DC7F5;
            transform: translateY(5px);
        }
        .img_box{
            width:440px;
            height: 270px;
            margin-left: 20px;
            margin-top: 15px;
        }
        .cank_box{
            width:388px;
            height: 363px;
        }
        .tuvlogo_box{
            width:195px;
            height: 195px;
            margin-left: 210px;
        }
        .mg_c{
            width: 100%;
        }
        .btm_banner{
            font-size: 14px;
            font-weight: 400;
            color: #666666;
            line-height: 20px;
            text-align: right;
            padding: 16px 0 0 0;
            border-top: 2px solid #013C89;
            margin-top: 105px;
        }
        .logo_txt{
            font-size: 14px;
            font-weight: 400;
            color: #666666;
            text-align: right;
            padding: 16px 0 0 0;
            justify-content: flex-end;
            border-top: 2px solid #013C89;
            margin-top: 280px;
            display: flex;
            align-items: center;
            .img_min{
                width: 20px;
                height: 20px;
                margin: 0 5px;
            }
        }
        .flxed{
            position: absolute;
            right: 20px;
            bottom: 20px;
            font-size: 24px;
            font-weight: 400;
            color: #333333;
            line-height: 33px;
        }
    }
}
.charts{
    width: 440px;
    height: 440px;
    margin: 10px 0 0 50px;
}
</style>